import { cn } from "~/lib/utils";
import { QuantityInputControl } from "~/components/Inputs/quantity-input-control/quantity-input-control";

import { AddButton } from "./add-button";

type StepperProps = {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  isIncrementDisabled?: boolean;
  isDecrementDisabled?: boolean;
  className?: string;
};

export const Stepper = ({
  value,
  onIncrement,
  onDecrement,
  isIncrementDisabled,
  isDecrementDisabled,
  className
}: StepperProps) => {
  if (value === 0) {
    return (
      <AddButton
        onClick={onIncrement}
        disabled={isIncrementDisabled}
        className={className}
      />
    );
  }

  return (
    <QuantityInputControl
      variant="primary"
      quantity={value}
      onIncrementClick={onIncrement}
      onDecrementClick={onDecrement}
      incrementDisabled={isIncrementDisabled}
      decrementDisabled={isDecrementDisabled}
      className={cn("w-full", className)}
    />
  );
};
